if ( pplang == 'zh-cn') {

    var zh_cn_strings =
    {
        "globals": {
            "_globalnotice": "按此登记",
            "_globalnotice2": regname+"门票现正接受登记！",
            "_globalnoticereg": "立即查看你的电子邮件！我们已经向你发送明天公开售票的指引。",
            "_maintenance": "Ultra Passport目前无法使用，请稍后再试。",
            "_guestnotice": "你必须先登录才可查看此页面。"
        },
        "form_labels": {
            "_fullname": "全名",
            "_firstname": "名字",
            "_lastname": "姓氏",
            "_email": "电邮",
            "_emailaddy": "电邮地址",
            "_confirmemailaddy": "确认电邮地址",
            "_birthday": "生日",
            "_location": "地区",
            "_country": "国家",
            "_homeevent": "所在地区活动",
            "_gender": "性別",
            "_password": "密码",
            "_male": "男性",
            "_female": "女性",
            "_pleaseselect": "请选择",
            "_signuptitle": "注册Ultra Passport",
            "_enteryouremail": "请输入你的电邮地址",
            "_backtologin": "返回登入页面",
            "_requestnewpass": "要求重新设置密码",
            "_on": "开启",
            "_off": "关闭"
        },
        "labels": {
            "_enrollmentavailable": "现正接受注册",
            "_logintext": "登入",
            "_password": "密码",
            "_welcome": "欢迎",
            "_account": "帐户",
            "_myaccount": "我的帐户",
            "_mypassport": "的Passport",
            "_events": "活动",
            "_points": "积分",
            "_updates": "最新消息",
            "_signout": "登出",
            "_signin": "登入",
            "_signedin": "已登入",
            "_signuptext": "注册",
            "_nextlevel": "下一级",
            "_forgot": "忘记密码？",
            "_subscribed": "订阅",
            "_helpcenter": "帮助中心",
            "_error": "错误",
            "_silver": "白银",
            "_gold": "黃金",
            "_platinum": "白金"
        },
        "validation_messages": {
            "_gendertext": "你必须选择性别。",
            "_accepttext": "你必须接受有关条款及细则"
        },
        "_email_verifications": {
            "_resendverify": "重新发送验证电子邮件",
            "_revalidate": "请检查你的电子邮箱以验证你的新电邮地址",
            "_sendingverification": "正在传送验证电邮",
            "_verifysent": "验证电邮已经传送",
            "_emailverifydashboard": "请务必认证你的电邮地址以获取更新和注册门票。",
            "_emailverifyupdates": "请务必认证你电邮地址作启用电邮更新"
        },
        "_edit_page": {
            "_editaccount": "编辑帐户\n",
            "_nochanges": "未检测到任何更改",
            "_accountupdated": "帐户已被更新\n",
            "_emailupdatedstarted": "新电邮地址必须经过验证，请检查您的电子邮箱以确认。",
            "_emailupdatedverified": "新电邮地址己被验证",
            "_passwordresetsent": "重置密码邮件已经发送"
        },
        "_footer_signup": {
            "_startinput": "请输入您的电邮地址以便开始",
            "_starttext": "没有帐户？登记注册<br class=\"small-hide\">以参加活动，赢取积分及其他奖赏！",
            "_getstarted": "立即开始"
        },
        "_signup_page": {
            "_createaccount": "建立我的帐户",
            "_almost": "即将完成",
            "_almost2": "恭喜$user_firstname成功创建您的Ultra Passport<span class=\"tm\"></span>帐户！",
            "_almost3": "若要激活你的帐户，<strong><u>你必须透过点击我们刚刚发送给阁下的电邮中</u>的确认链接以作验证你<strong>电邮地址之用</strong></strong>",
            "_almost4": "如果你没有收到任何电邮<strong><u>，请检查垃圾邮件信箱</u>并把</strong><strong></strong><u>info@e.ultrapassport.com</u>加到您的<strong><u></u></strong>通信录中",
            "_almost5": "继续",
            "_createdsuccess": "帐户己建立",
            "_createdinfo": "帐户正在创建中",
            "_accountactivated": "您的帐户现已激活。",
            "_accountverified": "您的电子邮件地址现在已经通过验证。",
            "_passwordresetsuccess": "密码重置成功"
        },
        "_updates": {
            "_updatestext1": "您必须登录才能登记接收更新。",
            "_updatestextPending": "请验证您的电邮地址以接收更新",
            "_updatessubsrcibe": "您订阅了以下的内容更新：",
            "_updatesunsubsrcibe": "您取消订阅了以下的内容更新："
        },
        "_registration": {
            "_rbtnbuy": "立即购买门票",
            "_regbuy": "购买门票",
            "_rbtnregister": "登记购买门票",
            "_rbtnclosed": "已关闭",
            "_rbtnsoon": "即将推出",
            "_rbtnupdates": "获取最新通知",
            "_verifyemailregister": "您必须在注册之前验证您的电邮地址。",
            "_regbtnhtml": "已注册",
            "_regerror": "错误！",
            "_regerror2": "请再尝试",
            "_regprocessing": "您的注册正在进行中...",
            "_registersuccess": "成功注册",
            "_regaccepted": "您的注册已被接受",
            "_regaccepted2": "购票指引已在开卖之前24-48小时发送至您的电邮。",
            "_regdone1": "注册编号",
            "_regdone2": "您已注册",
            "_regdone3": "重新发送购票指引"
        },
        "_registration_confirm": {
            "_regtext1": "你的个人资料是最新的吗？",
            "_regtext2": "请确认你的注册信息以",
            "_regguest1": "你必须先登录才能登记活动。",
            "_regpending1": "即将完成",
            "_regpending2": "请验证您<strong>的电邮地址</strong>以解锁注册权限。",
            "_updateinfobtn": "更新我的个人资料",
            "_confirmreg": "确认我的注册",
            "privacytext": "隐私政策",
            "termsofuse": "使用条款",
            "_agreesignup": "我同意Ultra Passport™的隐私政策和使用条款。",
            "_agreesignup2": "通过注册，你表示同意Ultra Passport™的隐私政策和使用条款。",
            "_agreeregister": "通过注册，你表示同意Ultra Passport™的隐私政策和使用条款。"
        },
        "_errors": {
            "reset": "无效的电邮地址或指令已过期。",
            "create": "创建失败，请确保已启用Cookie。",
            "general": "啊噢！出了些问题。请确保你已启用Cookie。",
            "password": "密码必须至少8个字符。",
            "matchemail": "你的电邮地址不符。请确认并重新输入您的电子邮件地址。",
            "duplicateemail": "此电邮帐户已被使用。",
            "loginfail": "你输入的用户名和密码与我们的记录不符，请仔细检查后再重试。\n",
            "token": "无效的指令，请尝试登录并<b>重新发送验证电子邮件</b>",
            "birthday" : "You must be 16 years of age or older to enroll in Ultra Passport.",
        },
        "_passport_labels": {
            "_action": "行动",
            "_awarded": "已获奖赏",
            "_award": "奖赏",
            "_pointsexpire": "*积分将在25个月后过期",
            "_qualifydisclaimer": "*请注意，“全部Ultra Festival”不包括：Road To Ultra，Ultra Beach和Resistance的活动。",
            "_benefit": "优待",
            "_sample": "已获积分",
            "_active": "活动中",
            "_deleted": "已删除",
            "_btn_dashboard": "仪表板",
            "_btn_benefits": "优待",
            "_btn_qualify": "合资格",
            "_btn_points": "我的积分",
            "_howtoqualify": "如何成为合资格会员"
        },
        "_point_labels": {
            "_points_manual": "Passport管理员调整",
            "_points_verify": "验证电邮帐户",
            "_points_attend_festival": "参加Road to Ultra的活动",
            "_points_away_bonus": "参加其他国家举行的活动",
            "_points_home_bonus_1": "参加所在地的活动",
            "_points_home_bonus_2": "参加所在地的活动X2",
            "_points_home_bonus_3": "参加所在地的活动X3"
        },

        /*"// PHP LABELS": {
            "$newpassword": "输入新密码",
            "$chooseanewpass": "请选择新密码",
            "$enteryouremail": "输入你的电邮地址",
            "$optional": "非必要"
        },
        "// BUTTON TEXT": {
            "$goback": "返回",
            "$login": "登入",
            "$signup": "注册",
            "$requestnewpass": "要求重新设置密码",
            "$buttonverify": "认证",
            "$resetpassword": "重新设置密码",
            "$createmyaccount": "创建我的账户",
            "$updatemyaccount": "更新我的账户",
            "$backtologin": "回到登入页面",
            "$forgotpass": "忘记密码？"
        },
        "// CONTENT": {
            "$abouttitle": "关于我",
            "$upptitle": "Passport详情",
            "$updatestext": "请选择你想要接收更新资讯的活动。",
            "$allupdates": "接收全部更新资讯\n",
            "$disableall": "取消所有选项",
            "$terms1": "我同意于",
            "$terms2": "通过注册，你同意",
            "$privacypolicy": "隐私政策",
            "$termsofuse": "使用条款",
            "$and": "还有",
            "$guestnotice": "你必须先登录才能访问此页面。",
            "$searchtext": "输入以搜寻活动..."
        },
        "// DASHBOARD": {
            "$myaccount": "的Passport",
            "$points": "积分",
            "$nextlevel": "下一级",
            "$name": "姓名",
            "$location": "地区",
            "$customerid": "客户身份证明编号",
            "$created": "创立",
            "$level": "级别",
            "$eventsbtn": "活动",
            "$updatesbtn": "最后消息",
            "$editaccount": "编辑帐户",
            "$ppdetails": "Passport详情",
            "$ppid": "Passport身份证明编号",
            "$ppunlock": "积分用作解锁下一个级别",
            "$status": "状态"
        },
        "// URL SLUGS": {
            "$accountpath": "passport",
            "$loginpath": "登入",
            "$signuppath": "注册",
            "$lostpath": "失去",
            "$resetpath": "重设",
            "$eventspath": "活动",
            "$verifypath": "认证",
            "$changeemail": "更改电邮地址",
            "$editpath": "编辑",
            "$updatespath": "最新消息"
        },
        "// PAGE TITLES": {
            "title_my_passport": "我的Passport",
            "title_Login": "登入",
            "title_ultra_passport_enrollment": "Ultra Passport登记",
            "title_reset_your_password": "重设您的密码",
            "title_update_your_password": "更新您的密码",
            "title_events": "活动",
            "title_verify": "验证",
            "title_change_email": "更改电邮地址",
            "title_edit_my_account": "编辑我的帐户",
            "title_manage_updates": "管理更新"
        },*/
        "_benefits": {
            "_silverbenefits_1": "领先大众一步登记取得Ultra活动的早鸟票",
            "_goldbenefits_1": "在白银级买家和普通大众前获得早期鸟票",
            "_goldbenefits_2": "使用单独的线路进入音乐节",
            "_goldbenefits_3": "进入Ultra Passport休息室",
            "_goldbenefits_4": "优先客户服务",
            "_platinumbenefits_1": "在黄金和白银级护照持有者和普通大众之前获得入场券",
            "_platinumbenefits_2": "视具体情况而定，访问特定观看平台以选择明星演出",
            "_platinumbenefits_3": "每个音乐节的特殊福利"
        },
        "_qualify": {
            "_qualify_1": "成功确认您的Ultra Passport登记",
            "_qualify_2": "参加一个完整的Ultra Festival",
            "_qualify_3": "参加Road To Ultra的活动",
            "_qualify_4": "奖励·参加您所在地区以外的任何一个国家的活动",
            "_qualify_5": "奖励·参加您所在地区内的本土活动",
            "_qualify_6": "奖励·连续两年参加您所在地区的本土活动\n",
            "_qualify_7": "奖励·连续三年参加您所在地区的本土活动（以及之后的任何连续年份）"
        },
        /*"Footer": {
            "email_footer_1": "此电子邮件是由ULTRA PASSPORT发出的",
            "email_footer_2": "如果您认为这是一个错误，请回复并让我们知道",
            "email_footer_3": "由Ultra Passport授权"
        },
        "Account Confirmation": {
            "email_account_confirmation_subject": "Ultra Passport帐户确认",
            "email_account_confirmation_message": "请确认您的Ultra Passport的电邮地址",
            "email_account_confirmation_button": "激活帐户"
        },
        "Account Verified": {
            "email_account_verified_subject": "帐户已被验证",
            "email_account_verified_message": "您已成功确认您的Ultra Passport电邮地址。您现在可以登记活动，赚取积分，并提高您的Ultra Passport级别。",
            "email_account_verified_button": "查看活动"
        },
        "New Email Verification": {
            "email_new_email_verification_subject": "请验证您的新电邮地址",
            "email_new_email_verification_message": "请点击下面的按钮以确认您的新邮件：",
            "email_new_email_verification_button": "验证电邮地址"
        },
        "New Email Verified": {
            "email_new_email_verified_subject": "您的新电邮地址己被验证",
            "email_new_email_verified_message": "您已成功确认您新的Ultra Passport帐户电邮地址。",
            "email_new_email_verified_button": "查看活动"
        },
        "Forgot Password": {
            "email_forgot_password_subject": "重设您的Ultra Passport密码",
            "email_forgot_password_message": "点击下面的按钮以重设密码：",
            "email_forgot_password_button": "重设密码"
        },
        "Password Reset": {
            "email_password_reset_subject": "你的密码已重设",
            "email_password_reset_message": "这封电邮是通知您，您的密码己被重设",
            "email_password_reset_button": "我的帐户"
        },
        "No Account": {
            "email_no_account_subject": "此帐户不存在",
            "email_no_account_message": "我们无法找到任何与％email％关联的帐户，请于以下创立你的帐户。",
            "email_no_account_button": "立即注册"
        },
        "EMAIL LABELS": {
            "email_label_intro": "亲爱的 (名字)",
            "email_label_intro_guest": "亲爱的顾客",
            "email_label_confirm_receipt": "此电子邮件确认我们已收到以下信息。如果需要回覆，我们会尽快与你联系。",
            "email_label_sent_from": "发送来自",
            "email_label_generated": "这封电子邮件是通过$website_link网站提交的。如果这是一个错误，请回复并告诉我们",
            "email_label_contact_request": "联络请求",
            "email_label_point_of_contact": "您收到此电子邮件是因为您是.get_bloginfo（姓名）的联系人。如果您不想再收到这些电子邮件，请通知我们",
            "email_label_terms_of_use": "使用条款",
            "email_label_privacy_policy": "私隐条例"
        },
        "Form Fields": {
            "email_form_success": "成功",
            "email_form_thank_you": "（name）感谢您联系[sitename]。 <br><br>我们会尽快回复您。"
        }*/
    };


  var

  // Config = '// Config',
    locale = 'zh-cn',
    helpurl = 'https://ultrapassport.com/help/',
    _lwidth = '3em';


  // Globals = '// Globals',
    _globalnotice    = zh_cn_strings['globals']['_globalnotice'];
    _globalnotice2   = zh_cn_strings['globals']['_globalnotice2'];
    _globalnoticereg = zh_cn_strings['globals']['_globalnoticereg'];
    _maintenance     = zh_cn_strings['globals']['_maintenance'];
    _guestnotice     = zh_cn_strings['globals']['_guestnotice'];

  // Labels = '// Labels',
    _fullname            = zh_cn_strings['form_labels']['_fullname'];
    _firstname           = zh_cn_strings['form_labels']['_firstname'];
    _lastname            = zh_cn_strings['form_labels']['_lastname'];
    _email               = zh_cn_strings['form_labels']['_email'];
    _emailaddy           = zh_cn_strings['form_labels']['_emailaddy'];
    _confirmemailaddy    = zh_cn_strings['form_labels']['_confirmemailaddy'];
    _birthday            = zh_cn_strings['form_labels']['_birthday'];
    _location            = zh_cn_strings['form_labels']['_location'];
    _country             = zh_cn_strings['form_labels']['_country'];
    _homeevent           = zh_cn_strings['form_labels']['_homeevent'];
    _gender              = zh_cn_strings['form_labels']['_gender'];
    _password            = zh_cn_strings['form_labels']['_password'];
    _male                = zh_cn_strings['form_labels']['_male'];
    _female              = zh_cn_strings['form_labels']['_female'];
    _pleaseselect        = zh_cn_strings['form_labels']['_pleaseselect'];
    _signuptitle         = zh_cn_strings['form_labels']['_signuptitle'];
    _enteryouremail      = zh_cn_strings['form_labels']['_enteryouremail'];
    _backtologin         = zh_cn_strings['form_labels']['_backtologin'];
    _requestnewpass      = zh_cn_strings['form_labels']['_requestnewpass'];
    _on                  = zh_cn_strings['form_labels']['_on'];
    _off                 = zh_cn_strings['form_labels']['_off'];
    _enrollmentavailable = zh_cn_strings['labels']['_enrollmentavailable'];
    _goback = '返回';


  // Text Labels = '// Text Labels',
    _logintext  = zh_cn_strings['labels']['_logintext'];
    _password   = zh_cn_strings['labels']['_password'];
    _welcome    = zh_cn_strings['labels']['_welcome'];
    _account    = zh_cn_strings['labels']['_account'];
    _myaccount  = zh_cn_strings['labels']['_myaccount'];
    _mypassport = zh_cn_strings['labels']['_mypassport'];
    _events     = zh_cn_strings['labels']['_events'];
    _points     = zh_cn_strings['labels']['_points'];
    _updates    = zh_cn_strings['labels']['_updates'];
    _signout    = zh_cn_strings['labels']['_signout'];
    _signin     = zh_cn_strings['labels']['_signin'];
    _signedin   = zh_cn_strings['labels']['_signedin'];
    _signuptext = zh_cn_strings['labels']['_signuptext'];
    _nextlevel  = zh_cn_strings['labels']['_nextlevel'];
    _forgot     = zh_cn_strings['labels']['_forgot'];
    _subscribed = zh_cn_strings['labels']['_subscribed'];
    _helpcenter = zh_cn_strings['labels']['_helpcenter'];
    _error      = zh_cn_strings['labels']['_error'];
    _silver     = zh_cn_strings['labels']['_silver'];
    _gold       = zh_cn_strings['labels']['_gold'];
    _platinum   = zh_cn_strings['labels']['_platinum'];

  // Validation Messages = '// Validation Messages',
    _gendertext = zh_cn_strings['validation_messages']['_gendertext'];
    _accepttext = zh_cn_strings['validation_messages']['_accepttext'];


  // Email Verifications = '// Email Verifications',
    _resendverify         = zh_cn_strings['_email_verifications']['_resendverify'];
    _revalidate           = zh_cn_strings['_email_verifications']['_revalidate'];
    _sendingverification  = zh_cn_strings['_email_verifications']['_sendingverification'];
    _verifysent           = zh_cn_strings['_email_verifications']['_verifysent'];
    _emailverifydashboard = zh_cn_strings['_email_verifications']['_emailverifydashboard'];
    _emailverifyupdates   = zh_cn_strings['_email_verifications']['_emailverifyupdates'];


  // Edit Page = '// Edit Page',
    _editaccount          = zh_cn_strings['_edit_page']['_editaccount'];
    _nochanges            = zh_cn_strings['_edit_page']['_nochanges'];
    _accountupdated       = zh_cn_strings['_edit_page']['_accountupdated'];
    _emailupdatedstarted  = zh_cn_strings['_edit_page']['_emailupdatedstarted'];
    _emailupdatedverified = zh_cn_strings['_edit_page']['_emailupdatedverified'];
    _passwordresetsent    = zh_cn_strings['_edit_page']['_passwordresetsent'];


  // Footer Signup = '// Footer Signup',
    _startinput = zh_cn_strings['_footer_signup']['_startinput'];
    _starttext  = zh_cn_strings['_footer_signup']['_starttext'];
    _getstarted = zh_cn_strings['_footer_signup']['_getstarted'];


  // Signup Page = '// Signup Page',
    _createaccount        = zh_cn_strings['_signup_page']['_createaccount'];
    _almost               = zh_cn_strings['_signup_page']['_almost'];
    _almost2              = zh_cn_strings['_signup_page']['_almost2'];
    _almost3              = zh_cn_strings['_signup_page']['_almost3'];
    _almost4              = zh_cn_strings['_signup_page']['_almost4'];
    _almost5              = zh_cn_strings['_signup_page']['_almost5'];
    _createdsuccess       = zh_cn_strings['_signup_page']['_createdsuccess'];
    _createdinfo          = zh_cn_strings['_signup_page']['_createdinfo'];
    _accountactivated     = zh_cn_strings['_signup_page']['_accountactivated'];
    _accountverified      = zh_cn_strings['_signup_page']['_accountverified'];
    _passwordresetsuccess = zh_cn_strings['_signup_page']['_passwordresetsuccess'];


  // Updates = '// Updates',
    _updatestext1       = zh_cn_strings['_updates']['_updatestext1'];
    _updatestextPending = zh_cn_strings['_updates']['_updatestextPending'];
    _updatessubsrcibe   = zh_cn_strings['_updates']['_updatessubsrcibe'];
    _updatesunsubsrcibe = zh_cn_strings['_updates']['_updatesunsubsrcibe'];


  // Registration = '// Registration',
    _rbtnbuy             = zh_cn_strings['_registration']['_rbtnbuy'];
    _regbuy              = zh_cn_strings['_registration']['_regbuy'];
    _rbtnregister        = zh_cn_strings['_registration']['_rbtnregister'];
    _rbtnclosed          = zh_cn_strings['_registration']['_rbtnclosed'];
    _rbtnsoon            = zh_cn_strings['_registration']['_rbtnsoon'];
    _rbtnupdates         = zh_cn_strings['_registration']['_rbtnupdates'];
    _verifyemailregister = zh_cn_strings['_registration']['_verifyemailregister'];
    _regbtnhtml          = zh_cn_strings['_registration']['_regbtnhtml'];
    _regerror            = zh_cn_strings['_registration']['_regerror'];
    _regerror2           = zh_cn_strings['_registration']['_regerror2'];
    _regprocessing       = zh_cn_strings['_registration']['_regprocessing'];
    _registersuccess     = zh_cn_strings['_registration']['_registersuccess'];
    _regaccepted         = zh_cn_strings['_registration']['_regaccepted'];
    _regaccepted2        = zh_cn_strings['_registration']['_regaccepted2'];
    _regaccepted2_2      = zh_cn_strings['_registration']['_regaccepted2_2'];
    _regaccepted2_3      = zh_cn_strings['_registration']['_regaccepted2_3'];
    _regaccepted3        = zh_cn_strings['_registration']['_regaccepted3'];
    _regdone1            = zh_cn_strings['_registration']['_regdone1'];
    _regdone2            = zh_cn_strings['_registration']['_regdone2'];
    _regdone3            = zh_cn_strings['_registration']['_regdone3'];
    _selectregtype = '选择登记类别';
    _regtype = '登记类别';


  // Registrations Confirm = '// Registrations Confirm',
    _regtext1      = zh_cn_strings['_registration_confirm']['_regtext1'];
    _regtext2      = zh_cn_strings['_registration_confirm']['_regtext2'];
    _regguest1     = zh_cn_strings['_registration_confirm']['_regguest1'];
    _regpending1   = zh_cn_strings['_registration_confirm']['_regpending1'];
    _regpending2   = zh_cn_strings['_registration_confirm']['_regpending2'];
    _updateinfobtn = zh_cn_strings['_registration_confirm']['_updateinfobtn'];
    _confirmreg    = zh_cn_strings['_registration_confirm']['_confirmreg'];


  // Privacy / Terms Notice = '// Privacy / Terms Notice',
    privacytext = zh_cn_strings['privacytext'];
    termsofuse  = zh_cn_strings['termsofuse'];

  // Copyright == '// Copyright ',
    upptextlogo    = 'Ultra Passport<span class="tm">&trade;</span>';
    privacylink    = `<a href="https://ultrapassport.com/privacy-policy" target="_blank">${zh_cn_strings['_registration_confirm']['privacytext']}</a>`;
    termslink      = `<a href="https://ultrapassport.com/terms-of-use" target="_blank">${zh_cn_strings['_registration_confirm']['termsofuse']}</a>`;
    _agreesignup   = zh_cn_strings['_registration_confirm']['_agreesignup'];
    _agreesignup2  = zh_cn_strings['_registration_confirm']['_agreesignup2'];
    _agreeregister = zh_cn_strings['_registration_confirm']['_agreeregister'];


  // Passport Dashboard = '// Passport Dashboard',
    _action            = zh_cn_strings['_passport_labels']['_action'];
    _awarded           = zh_cn_strings['_passport_labels']['_awarded'];
    _award             = zh_cn_strings['_passport_labels']['_award'];
    _benefit           = zh_cn_strings['_passport_labels']['_benefit'];
    _howtoqualify      = zh_cn_strings['_passport_labels']['_howtoqualify'];
    _pointsexpire      = zh_cn_strings['_passport_labels']['_pointsexpire'];
    _qualifydisclaimer = zh_cn_strings['_passport_labels']['_qualifydisclaimer'];
    _active            = zh_cn_strings['_passport_labels']['_active'];
    _deleted           = zh_cn_strings['_passport_labels']['_deleted'];
    _btn_dashboard     = zh_cn_strings['_passport_labels']['_btn_dashboard'];
    _btn_benefits      = zh_cn_strings['_passport_labels']['_btn_benefits'];
    _btn_qualify       = zh_cn_strings['_passport_labels']['_btn_qualify'];
    _btn_points        = zh_cn_strings['_passport_labels']['_btn_points'];

    leveltext = _silver;
    nextlevel = _gold;

    var _birthdayselect = '<div class="datefield"><span class="subfield monthfield"><select class="required" id="birthmonth" name="birthmonth" style="width:80px;display:inline-block"><option value="" disabled selected>MM</option><option value="01">1</option><option value="02">2</option><option value="03">3</option><option value="04">4</option><option value="05">5</option><option value="06">6</option><option value="07">7</option><option value="08">8</option><option value="09">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option></select></span><span class="spacer">/</span> <span class="subfield dayfield"><select class="required" id="birthday" name="birthday" style="width:80px;display:inline-block" data-field="birthday"><option value="" disabled selected>DD</option><option value="01">1</option><option value="02">2</option><option value="03">3</option><option value="04">4</option><option value="05">5</option><option value="06">6</option><option value="07">7</option><option value="08">8</option><option value="09">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option><option value="13">13</option><option value="14">14</option><option value="15">15</option><option value="16">16</option><option value="17">17</option><option value="18">18</option><option value="19">19</option><option value="20">20</option><option value="21">21</option><option value="22">22</option><option value="23">23</option><option value="24">24</option><option value="25">25</option><option value="26">26</option><option value="27">27</option><option value="28">28</option><option value="29">29</option><option value="30">30</option><option value="31">31</option></select></span><span class="spacer">/</span> <span class="subfield yearfield"><select class="required" id="birthyear" name="birthyear" style="width:100px;display:inline-block"><option disabled selected>YYYY</option><option value="2017">2017</option><option value="2016">2016</option><option value="2015">2015</option><option value="2013">2013</option><option value="2012">2012</option><option value="2011">2011</option><option value="2010">2010</option><option value="2009">2009</option><option value="2008">2008</option><option value="2007">2007</option><option value="2006">2006</option><option value="2005">2005</option><option value="2004">2004</option><option value="2003">2003</option><option value="2002">2002</option><option value="2001">2001</option><option value="2000">2000</option><option value="1999">1999</option><option value="1998">1998</option><option value="1997">1997</option><option value="1996">1996</option><option value="1995">1995</option><option value="1994">1994</option><option value="1993">1993</option><option value="1992">1992</option><option value="1991">1991</option><option value="1990">1990</option><option value="1989">1989</option><option value="1988">1988</option><option value="1987">1987</option><option value="1986">1986</option><option value="1985">1985</option><option value="1984">1984</option><option value="1983">1983</option><option value="1982">1982</option><option value="1981">1981</option><option value="1980">1980</option><option value="1979">1979</option><option value="1978">1978</option><option value="1977">1977</option><option value="1976">1976</option><option value="1975">1975</option><option value="1974">1974</option><option value="1973">1973</option><option value="1972">1972</option><option value="1971">1971</option><option value="1970">1970</option><option value="1969">1969</option><option value="1968">1968</option><option value="1967">1967</option><option value="1966">1966</option><option value="1965">1965</option><option value="1964">1964</option><option value="1963">1963</option><option value="1962">1962</option><option value="1961">1961</option><option value="1960">1960</option><option value="1959">1959</option><option value="1958">1958</option><option value="1957">1957</option><option value="1956">1956</option><option value="1955">1955</option><option value="1954">1954</option><option value="1953">1953</option><option value="1952">1952</option><option value="1951">1951</option><option value="1950">1950</option><option value="1949">1949</option><option value="1948">1948</option><option value="1947">1947</option><option value="1946">1946</option><option value="1945">1945</option><option value="1944">1944</option><option value="1943">1943</option><option value="1942">1942</option><option value="1941">1941</option><option value="1940">1940</option><option value="1939">1939</option><option value="1938">1938</option><option value="1937">1937</option><option value="1936">1936</option><option value="1935">1935</option><option value="1934">1934</option><option value="1933">1933</option><option value="1932">1932</option><option value="1931">1931</option><option value="1930">1930</option><option value="1929">1929</option><option value="1928">1928</option><option value="1927">1927</option><option value="1926">1926</option><option value="1925">1925</option><option value="1924">1924</option><option value="1923">1923</option><option value="1922">1922</option><option value="1921">1921</option><option value="1920">1920</option><option value="1919">1919</option><option value="1918">1918</option><option value="1917">1917</option><option value="1916">1916</option><option value="1915">1915</option><option value="1914">1914</option><option value="1913">1913</option><option value="1912">1912</option><option value="1911">1911</option><option value="1910">1910</option><option value="1909">1909</option><option value="1908">1908</option><option value="1907">1907</option><option value="1906">1906</option><option value="1905">1905</option><option value="1904">1904</option><option value="1903">1903</option><option value="1902">1902</option><option value="1901">1901</option><option value="1900">1900</option></select></span></div>';

    // Errors : '// Errors',
    var errors = zh_cn_strings['_errors'];

    // Point Labels : '// Point Labels'
    var pointcodes = {
        manual : zh_cn_strings['_point_labels']['_points_manual'],
        verify : zh_cn_strings['_point_labels']['_points_verify'],
        unknown : 'Passport Admin Adjustment',
        attend_festival : zh_cn_strings['_point_labels']['_points_attend_festival'],
        attend_rtu : zh_cn_strings['_point_labels']['_points_attend_rtu'],
        attend_resistance : 'Attend a Resistance Only Event',
        away_bonus : zh_cn_strings['_point_labels']['_points_away_bonus'],
        home_bonus_1 : zh_cn_strings['_point_labels']['_points_home_bonus_1'],
        home_bonus_2 : zh_cn_strings['_point_labels']['_points_home_bonus_2'],
        home_bonus_3 : zh_cn_strings['_point_labels']['_points_home_bonus_3'],
    };

}
